import type {$Fetch} from "nitropack";
import baseRepository from "~/api/BaseRepository";

export const PageRepository = (client: $Fetch) => ({
    ...baseRepository(client)('v2/pages'),
    
    getByMissionId(id: string) {
        return client(`/v2/missions/${id}/pages`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            }
        }) as Promise<any>;
    }
})